import React from 'react';
import { Paper, Typography, CircularProgress, Button } from '@material-ui/core';

//css
import StylesCss from './styles';
const useStyles = StylesCss();

const form = (props) => {
    const classes = useStyles();
    return (
        <div align={'center'} style={{marginTop:'150px'}}>
            <Paper elevation={2} style={{width:'500px',height:'350px'}}>
            {props.state.isLoading &&
                <div align="center">
                    <CircularProgress />
                </div>
            }
            {!props.state.isLoading &&
                <div className={classes.buttonFile}>
                    <input
                        accept=".pdf"
                        className={classes.input}
                        id="btFile"
                        multiple
                        onChange={props.handlerArquivo}
                        type="file"
                    />                                          
                    <div className={classes.lb_arquivo}>
                        {props.state.nomeArquivo}
                    </div>
                    <label htmlFor="btFile">
                        <Button raised="true" component="span" variant="contained" color="primary" >
                            Upload do Arquivo
                        </Button>
                    </label>
                    <Typography id={"extensao"} className={classes.cardFileText} color="textSecondary" gutterBottom>
                        Extensões permitidas: .pdf.
                    </Typography>
                    <Typography id={"tamanho"} className={classes.cardFileText} color="textSecondary" gutterBottom>
                        Tamanho máximo de arquivo 5mb.
                    </Typography>
                </div>
            }
            </Paper>
        </div>
    );
};

export default form;